// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectPremiseOfValueQueryResult, selectPremiseOfValuesPageLoading, selectPremiseOfValuesShowInitWaitingMessage} from '../_selectors/premise-of-value.selectors';

export class PremiseOfValuesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectPremiseOfValuesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectPremiseOfValuesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectPremiseOfValueQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
